import {LandingSiteRouteNames} from "./route-names.enum";

export const formatPath = (page: LandingSiteRouteNames) => {
  return `/${page}`
}
